module.exports = __webpack_public_path__ + "img/bg-ship-bridge.8db0a221.jpg";